module.exports = __webpack_public_path__ + "fonts/sourcesansproblackitalic.010f7d73.woff2";